import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 12L14.57 5L16 6.38L10.72 12L16 17.62L14.57 19L8 12Z" fill={ fill || 'currentColor' } />
    </svg>
);
